import React from "react";
import c1 from "../assets/images/c1.jpg";
import c2 from "../assets/images/c2.jpg";
import c3 from "../assets/images/c3.jpeg";
import c4 from "../assets/images/c4.jpeg";
import c5 from "../assets/images/c5.jpeg";
import c6 from "../assets/images/c6.jpeg";
import c7 from "../assets/images/c7.jpeg";
import c8 from "../assets/images/c8.jpg";
import c9 from "../assets/images/c9.jpeg";
import c10 from "../assets/images/c10.jpeg";
import c11 from "../assets/images/c11.jpeg";
import c12 from "../assets/images/c12.jpg";
import c13 from "../assets/images/c13.jpg";
import c14 from "../assets/images/c14.jpeg";
import '../assets/styles/Project.scss';

function Certificates() {
    return(
    <div className="projects-container" id="certificates">
        <h1>Certificates</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="http://www.astronomybangla.com/" target="_blank" rel="noreferrer"><img src={c1} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="http://www.astronomybangla.com/" target="_blank" rel="noreferrer"><h2>Bangladesh Astronomical Association</h2></a>
                <p>Participated in the 17th Bangladesh Astro-Olympiad 2022</p>
            </div>
            <div className="project">
                <a href="https://www.facebook.com/groups/isto2021/" target="_blank" rel="noreferrer"><img src={c2} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.facebook.com/groups/isto2021/" target="_blank" rel="noreferrer"><h2>International Science and Technology Olympiad</h2></a>
                <p>Qualified for the Quarter-Final Round of International Science and Technology Olympiad 2021-22</p>
            </div>
            <div className="project">
                <a href="https://www.facebook.com/jeec2012/" target="_blank" rel="noreferrer"><img src={c3} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.facebook.com/jeec2012/" target="_blank" rel="noreferrer"><h2>Josephite Eco Earth Club</h2></a>
                <p>Achieved the <b>Champion Award</b> in Biochemistry Olympiad (B) at the 4th Nature and Adventure Fest'21</p>
            </div>
            <div className="project">
                <a href="https://www.facebook.com/msb.esab/" target="_blank" rel="noreferrer"><img src={c4} className="zoom" alt="thumbnail" width="110%"/></a>
                <a href="https://www.facebook.com/msb.esab/" target="_blank" rel="noreferrer"><h2>Mars Society Bangladesh</h2></a>
                <p>For having an outstanding performance in "Astro Quiz" during Bangladesh Space Day - 2021</p>
            </div>
            <div className="project">
                <a href="https://sites.google.com/view/xenonsciencecongress" target="_blank" rel="noreferrer"><img src={c5} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://sites.google.com/view/xenonsciencecongress" target="_blank" rel="noreferrer"><h2>Xenon Science Congress</h2></a>
                <p>Achieved the <b>Runner Up</b> position in "Bangla Olympiad"</p>
            </div>
            <div className="project">
                <a href="https://www.facebook.com/Bosonbigganshongho/" target="_blank" rel="noreferrer"><img src={c6} className="zoom" alt="thumbnail" width="110%"/></a>
                <a href="https://www.facebook.com/Bosonbigganshongho/" target="_blank" rel="noreferrer"><h2>Boson Biggan Songho</h2></a>
                <p>Obtained an honoarable mention in Junior category of Biology Olympiad in "Bengal group presents JN Islam Mega Fest 2021"</p>
            </div>
            <div className="project">
                <a href="https://www.facebook.com/herodotus.historyclub/" target="_blank" rel="noreferrer"><img src={c7} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.facebook.com/herodotus.historyclub/" target="_blank" rel="noreferrer"><h2>Herodotous History Club</h2></a>
                <p>Achieved the <b>Runner-Up</b> position in the History Quiz presented by Flipbazz in "Herodotus Quiz Hunt," organized by the "Herodotus History Club"</p>
            </div>
            <div className="project">
                <a href="https://spsb.org/" target="_blank" rel="noreferrer"><img src={c8} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://spsb.org/" target="_blank" rel="noreferrer"><h2>বাংলাদেশ বিজ্ঞান জনপ্রিয়করণ কমিটি</h2></a>
                <p>Participated in the Secondary Category of the online regional round of Al-Arafah Islami Bank 7th Bangladesh Junior Science Olympiad (BdJSO 2021)"</p>
            </div>
            <div className="project">
                <a href="https://www.facebook.com/bangladesholympiadiansclub/" target="_blank" rel="noreferrer"><img src={c9} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.facebook.com/bangladesholympiadiansclub/" target="_blank" rel="noreferrer"><h2>Bangladesh Olympiadians Club</h2></a>
                <p>Achieved <b>1st Position</b> in Senior category at the Science Olympiad of "Junior Science Enthusiasts" organized by "Bangladesh Olympiadians Club".</p>
            </div>
            <div className="project">
                <a href="https://www.gwp.org/" target="_blank" rel="noreferrer"><img src={c10} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.gwp.org/" target="_blank" rel="noreferrer"><h2>GWP</h2></a>
                <p>Achieved Examplary Performance in GWP Presents "Explore The Nature"</p>
            </div>
             <div className="project">
                <a href="https://www.facebook.com/sputniksastrosociety/" target="_blank" rel="noreferrer"><img src={c11} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.facebook.com/sputniksastrosociety/" target="_blank" rel="noreferrer"><h2>Sopnil Bangladesh</h2></a>
                <p>Secured the <b>3rd Position</b> in "Ready to quiz?" organized by Sopnil Bangladesh</p>
            </div>
            <div className="project">
                <a href="https://www.facebook.com/southeasthorizon.org/" target="_blank" rel="noreferrer"><img src={c12} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.facebook.com/southeasthorizon.org/" target="_blank" rel="noreferrer"><h2>South-East Horizon</h2></a>
                <p>Secured the <b>5th Position</b> in "HORIZON MEGA SCIENCE OLYMPIAD (ADOBE)" segment in "SCIENTIFIC-ISLAMIC SWEEPSTAKES 1.0"</p>
            </div>
            <div className="project">
                <a href="https://www.facebook.com/southeasthorizon.org/" target="_blank" rel="noreferrer"><img src={c13} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.facebook.com/southeasthorizon.org/" target="_blank" rel="noreferrer"><h2>South-East Horizon</h2></a>
                <p>Secured the <b>10th Position</b> in "HORIZON MEGA OLYMPIAD" in "SCIENTIFIC-ISLAMIC SWEEPSTAKES 1.0"</p>
            </div>
            <div className="project">
                <a href="https://rnecofficial.com/" target="_blank" rel="noreferrer"><img src={c14} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://rnecofficial.com/" target="_blank" rel="noreferrer"><h2>Remians Nature & Earth Club</h2></a>
                <p>Secured the <b>2ndPosition</b> in the Nature and Geography Quiz (Senior) organized by Remians Nature & Earth Club from 28 May - 5 June 2021</p>
            </div>
        </div>
    </div>
    );
}

export default Certificates;